import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dropdown } from 'react-bootstrap'
import * as S from './style'
import { trans } from 'sharedKernel/i18n'

const mapStatus = (status: number): 'Cadastrado' | 'Não cadastrado' =>
  status === 1 ? 'Cadastrado' : 'Não cadastrado'

export interface IMember {
  id: string
  companyId: string
  name: string
  email: string
  position: string
  status: number
}

interface MembersTableProps {
  members: IMember[]
  onResendEmail: (member: IMember) => void
  onRemove: (member: IMember) => void
}

export const MembersTable = ({ members, onResendEmail, onRemove }: MembersTableProps): JSX.Element => {
  const isEmpty = members.length === 0

  return (
    <S.TableContainer>
      <S.TableHead>
        <div>{trans('Nome')}</div>
        <div>{trans('E-mail')}</div>
        <div>{trans('Cargo')}</div>
        <div>{trans('Status')}</div>
        <div style={{ textAlign: 'right' }}>{trans('Ações')}</div>
      </S.TableHead>
      {isEmpty ? (
        <S.TableRow style={{ display: 'block', padding: '40px', textAlign: 'center' }}>
          <div>{trans('Ainda não há membros cadastrados')}</div>
        </S.TableRow>
      ) : (
        members.map((member) => (
          <S.TableRow key={member.id}>
            <S.RowValue>{member.name}</S.RowValue>
            <S.RowValue>{member.email}</S.RowValue>
            <S.RowValue>{member.position}</S.RowValue>
            <S.StatusText>{mapStatus(member.status)}</S.StatusText>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <S.ActionsDropdownButton
                id={`dropdown-actions-${member.id}`}
                title={<FontAwesomeIcon icon={['fas', 'ellipsis-vertical']} style={{ color: '#0066B3' }} />}
                variant="link"
                align="end"
                flip
                popperConfig={{ strategy: 'fixed' }}
              >
                <Dropdown.Item
                  onClick={() => onResendEmail(member)}
                  disabled={member.status === 1}
                >
                  <FontAwesomeIcon icon={['fas', 'envelope']} className="me-2" />
                  {trans('Reenviar e-mail')}
                </Dropdown.Item>
                <Dropdown.Item onClick={() => onRemove(member)}>
                  <FontAwesomeIcon icon={['fas', 'trash']} className="me-2" />
                  {trans('Remover')}
                </Dropdown.Item>
              </S.ActionsDropdownButton>
            </div>
          </S.TableRow>
        ))
      )}
    </S.TableContainer>
  )
}
